import { render, staticRenderFns } from "./NotesV2.vue?vue&type=template&id=16e580d4&"
import script from "./NotesV2.vue?vue&type=script&lang=js&"
export * from "./NotesV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports